import React from "react";
import LaufaskolinnPage from "@components/Pages/LaufaskolinnPage";

export default function Laufaskolinn() {
    return <LaufaskolinnPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
